import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';
import withReactContent from "sweetalert2-react-content";
import swal from "sweetalert2";
import { getDefaultStyles } from '../../../../helpers/getDefaultStyles';
import { getPromoterTheme, updatePromoterTheme } from '../../../../store/actions/promoterActions';
import NewLoader from '../../../../components/NewLoader/NewLoader';

import './ThemesPage.sass';
import { ThemeSettings } from '../../../../components/Themes/ThemeSettings/ThemeSettings';

const MySwal = withReactContent(swal);

export const PromoterThemesPage = ({ token, loading, getPromoterTheme, updatePromoterTheme }) => {
  const {
    fontFamily,
    primaryColor,
    primarySemiLightColor,
    primaryLightColor,
    secondaryColor,
    secondaryLightColor,
    backgroundColor,
    textColor,
    secondaryTextColor,
  } = getDefaultStyles(document.getElementById('body'));

  const [theme, setTheme] = useState({
    fontFamily,
    primaryColor,
    primarySemiLightColor,
    primaryLightColor,
    secondaryColor,
    secondaryLightColor,
    backgroundColor,
    primaryTextColor: textColor,
    secondaryTextColor,
  });

  const [isThemeEdited, setThemeEdited] = useState(false);

  const getData = async () => {
    const data = await getPromoterTheme(token);

    if (data) {
      setTheme(data);
    }
  }

  const handleChangeSetting = (name, value) => {
    setThemeEdited(true);
    setTheme((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const saveTheme = () => {
    MySwal.fire({
      title: "Do you want to save changes?",
      customClass: 'swal2-modal',
      showCancelButton: true,
      confirmButtonText: 'Save',
      reverseButtons: true,
    }).then((result) => {
      
      if (result.value) {
        updatePromoterTheme(token, theme)
          .then(() => setThemeEdited(false));
      }
    });
  }

  useEffect(() => {
    getData();
  }, []);

  if (loading) {
    return <NewLoader />;
  }

  return (
    <section className="promoter-theme">
      <ThemeSettings theme={theme} handleChangeSetting={handleChangeSetting} />

      <div className="promoter-theme__buttons-container">
        <button
          type='button'
          className='btn-primary'
          onClick={saveTheme}
          disabled={!isThemeEdited}
        >
          Save
        </button>
      </div>
    </section>
  )
}

const mapStateToProps = ({ auth, promoter }) => ({
  token: auth.user.token,
  loading: promoter.loading,
  theme: promoter.theme,
});

const mapDispatchToProps = (dispatch) => ({
  getPromoterTheme: (token) => dispatch(getPromoterTheme(token)),
  updatePromoterTheme: (token, theme) => dispatch(updatePromoterTheme(token, theme)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PromoterThemesPage));
